module.exports = __webpack_public_path__ + "static/media/videoBadgeLevel4Locked.c89e9fe4.png";